import type { ReactNode } from "react";

interface SearchResultRowProps {
	icon: ReactNode;
	title: string;
	subtitle?: string;
	onSelect: () => void;
}

export function SearchResultRow({ icon, title, subtitle, onSelect }: SearchResultRowProps) {
	return (
		<button type="button" onClick={onSelect} className="flex w-full items-center gap-3 px-3 py-2 text-left text-sm hover:bg-default-100">
			<span className="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-default-100">{icon}</span>
			<span className="min-w-0 flex-1">
				<span className="block truncate font-medium text-foreground">{title}</span>
				{subtitle && <span className="block truncate text-xs text-foreground/60">{subtitle}</span>}
			</span>
		</button>
	);
}
